/**
 * Formats an array of values by joining them with commas.
 * If input is a JSON string, it will be parsed first.
 *
 * @param values - Array of values, JSON string, or any other value
 * @returns If array: comma-separated string. Otherwise: value as-is
 *
 * @example
 * // Array input
 * formatListOfValues(['value1', 'value2', 'value3'])
 * // Returns: "value1, value2, value3"
 *
 * @example
 * // JSON string input
 * formatListOfValues('["value1", "value2"]')
 * // Returns: "value1, value2"
 *
 * @example
 * // Non-array input
 * formatListOfValues('2024-06-15')
 * // Returns: "2024-06-15"
 */
export function formatListOfValues(values: unknown): unknown {
  let parsed = values;

  // Try to parse if it's a string
  if (typeof values === "string") {
    try {
      parsed = JSON.parse(values);
    } catch {
      // If parsing fails, keep the original string
      return values;
    }
  }

  // If the parsed result is an array, join it
  if (Array.isArray(parsed)) {
    return parsed.join(", ");
  }

  // Otherwise return as-is
  return values;
}
